import React from 'react';
import ReactDOM from 'react-dom';
import videojs from 'video.js';

const vjsComponent = videojs.getComponent('Component');

const addElementToVideojs = (
  parentNode,
  player,
  Component,
  props,
  position
) => {
  parentNode.addChild(new AddElement(player, Component, props), {}, position);
};

class AddElement extends vjsComponent {
  constructor(player, Component, props, action) {
    super(player);
    this.props = props;
    this.Component = Component;
    this.action = action;
    this.player = player;

    /* Bind the current class context to the mount method */
    this.mount = this.mount.bind(this);

    /* When player is ready, call method to mount React component */
    player.ready(() => {
      this.mount();
    });

    /* Remove React root when component is destroyed */
    this.on('dispose', () => {
      ReactDOM.unmountComponentAtNode(this.el());
    });
  }

  mount() {
    const Component = this.Component;
    ReactDOM.render(
      <Component vjsComponent={this} {...this.props} player={this.player} />,
      this.el()
    );
  }
}

export default addElementToVideojs;
